import { datadogRum } from "@datadog/browser-rum";

export function initializeDatadogRum() {
  const clientToken = import.meta.env.VITE_DD_CLIENT_TOKEN;
  const applicationId = import.meta.env.VITE_DD_APPLICATION_ID;
  const allowedTracingUrl = import.meta.env.VITE_API_URL;

  if (!clientToken || !applicationId) {
    return;
  }

  const site = import.meta.env.VITE_DD_SITE;
  const service = import.meta.env.VITE_DD_SERVICE;
  const env = import.meta.env.VITE_DD_ENV;
  const version = import.meta.env.VITE_DD_VERSION;

  datadogRum.init({
    applicationId,
    clientToken,
    ...(site ? { site } : {}),
    ...(service ? { service } : {}),
    ...(env ? { env } : {}),
    ...(version ? { version } : {}),
    ...(allowedTracingUrl ? { allowedTracingUrls: [allowedTracingUrl] } : {}),
    sessionSampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    enablePrivacyForActionName: true,
  });
}
